<template>
  <div class="Winning-box">
    <div class="Winning" v-for="item in WinningLotteryData">
      <img :src="item.adInfo?.pictureUrl || item.adInfo?.conditionMap.positionResourceFile1[0].value">
      <div class="Winninggoods">
        <div>{{ item.prizeName }}</div>
        <div>库迪客服将电话通知您兑奖细则</div>
      </div>
    </div>
    <div class="divider"></div>
  </div>
</template>

<script>
export default {
  name: "Winning",
  props:{
    WinningLotteryData:{
      type: Array,
      default: [],
    }
  },
  watch:{
  }
}
</script>

<style lang="scss" scoped>
.Winning-box{
  width: 100%;
  height: 100%;

  .Winning{
    display: flex;
    width: 100%;
    margin-bottom: 32px;

    img{
      width: 228px;
      height: 160px;
      border-radius: 8px;
    }

    .Winninggoods{
      margin: 4px 0 4px 24px;
      flex: 1;
      display: flex;
      flex-flow: column;
      justify-content: space-between;

      div:first-child{
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3A3B3C;
        width: 100%;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
        overflow: hidden;
      }

      div:last-child{
        width: 100%;
        font-size: 22px;
        color: #5E5E5E;
        font-weight: 400;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* 这里是超出几行省略 */
        overflow: hidden;
      }
    }
  }

  //.divider{
  //  margin: 32px 0 30px 0;
  //  width: 100%;
  //  height: 2px;
  //  background: #EEEEEE;
  //}

}
</style>
